import { render, staticRenderFns } from "./TemporaryAuthLayoutComponent.vue?vue&type=template&id=927daf4e&"
import script from "./TemporaryAuthLayoutComponent.vue?vue&type=script&lang=js&"
export * from "./TemporaryAuthLayoutComponent.vue?vue&type=script&lang=js&"
import style0 from "./TemporaryAuthLayoutComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports